import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { LoadingPanel } from '../../workspace/pages/common.js';
import { NotAvailablePage } from '../../workspace/pages/NotAvailablePage.js';
import { useSession } from '../../workspace/session.js';

/**
 * The merchant wall. Loading renders a spinner, never a guess; an anonymous
 * visitor is sent to the public intake preview; any other role sees the
 * shared "not available" page. Fails closed on every uncertainty.
 */
export function RequireMerchant({
  children,
}: {
  readonly children: ReactNode;
}): ReactNode {
  const { session } = useSession();
  if (session.status === 'loading') return <LoadingPanel />;
  if (session.status === 'anonymous') {
    return <Navigate to="/business-profile" replace />;
  }
  if (session.account.role !== 'MERCHANT') return <NotAvailablePage />;
  return children;
}
